(function(){
  if (window.__cardVariantThumbsInit) return;
  window.__cardVariantThumbsInit = true;

  function findCardRoot(el){
    return el.closest('[data-card-root]') || el.closest('.card-wrapper');
  }

  function getVariants(cardRoot){
    const jsonEl = cardRoot.querySelector('[data-variants-json]');
    if(!jsonEl) return null;
    try { return JSON.parse(jsonEl.textContent); } catch(e){ return null; }
  }

  function setActive(picker, id){
    picker.querySelectorAll('.variant-thumb').forEach(function(btn){
      btn.classList.toggle('is-active', String(btn.dataset.variantId) === String(id));
    });
  }

  function updateVariantInput(cardRoot, variant){
    const input = cardRoot.querySelector('[data-variant-input]');
    if(input) input.value = variant.id;

    const btn = cardRoot.querySelector('.quick-add__submit');
    if(btn){
      if(variant.available) btn.removeAttribute('disabled');
      else btn.setAttribute('disabled','disabled');
    }
  }

  function withWidth(url, w){
    if(!url) return url;
    // garante https e adiciona width (Shopify CDN entende ?width=)
    let u = String(url);
    if (u.startsWith('//')) u = 'https:' + u;
    if (u.indexOf('width=') !== -1) return u.replace(/width=\d+/,'width='+w);
    return u + (u.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w;
  }

  function buildSrcset(base){
    const widths = [165,360,533,720,940,1066];
    return widths.map(function(w){ return withWidth(base, w) + ' ' + w + 'w'; }).join(', ');
  }

  function pickVariantImageSrc(variant){
    return (
      (variant && variant.featured_image && variant.featured_image.src) ||
      (variant && variant.image && variant.image.src) ||
      (variant && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) ||
      null
    );
  }

  function updateMainImage(cardRoot, variant){
    const img =
      cardRoot.querySelector('[data-main-image]') ||
      cardRoot.querySelector('.card__media img.motion-reduce');

    if(!img) return;

    const baseSrc = pickVariantImageSrc(variant);
    if(!baseSrc) return;

    const newSrc = withWidth(baseSrc, 533);

    // 🔥 Atualiza src E srcset (senão o navegador continua exibindo pelo srcset antigo)
    img.setAttribute('src', newSrc);
    img.setAttribute('srcset', buildSrcset(baseSrc));

    // mantém sizes se existir; se não existir, não cria
    // força reload em alguns browsers/caches
    img.loading = img.loading || 'lazy';
    img.decoding = img.decoding || 'async';
  }

  function stopAll(e){
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function blockClick(e){
    e.preventDefault();
    stopAll(e);
  }

  function onSelect(e){
    const btn = e.target.closest('.variant-thumb');
    if(!btn) return;

    blockClick(e);

    if(btn.classList.contains('is-disabled')) return;

    const picker = btn.closest('[data-card-variant-picker]');
    if(!picker) return;

    const cardRoot = findCardRoot(picker);
    if(!cardRoot) return;

    const variants = getVariants(cardRoot);
    if(!variants) return;

    const id = btn.dataset.variantId;
    const variant = variants.find(function(v){ return String(v.id) === String(id); });
    if(!variant) return;

    setActive(picker, id);
    updateVariantInput(cardRoot, variant);
    updateMainImage(cardRoot, variant);

    if (btn.scrollIntoView){
      try{
        btn.scrollIntoView({ behavior:'smooth', inline:'center', block:'nearest' });
      }catch(err){
        btn.scrollIntoView();
      }
    }
  }

  document.addEventListener('click', onSelect, true);

  document.addEventListener('pointerdown', function(e){
    const b = e.target.closest && e.target.closest('.variant-thumb');
    if(b) stopAll(e);
  }, true);

  document.addEventListener('touchstart', function(e){
    const b = e.target.closest && e.target.closest('.variant-thumb');
    if(b) stopAll(e);
  }, true);
})();